"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsSecret = void 0;
const GlobalSQLite_1 = require("../GlobalSQLite");
const utilsFile_1 = require("./utilsFile");
const utilsSQLite_1 = require("./utilsSQLite");
class UtilsSecret {
    constructor() {
        this.globalUtil = new GlobalSQLite_1.GlobalSQLite();
        this.sqliteUtil = new utilsSQLite_1.UtilsSQLite();
        this.fileUtil = new utilsFile_1.UtilsFile();
        this.storage = require('electron-json-storage');
    }
    isPassphraseValid(passphrase) {
        let isValid = false;
        const secret = this.getPassphrase();
        if (secret === passphrase) {
            isValid = true;
        }
        return isValid;
    }
    isSecretStored() {
        const secret = this.getPassphrase();
        if (secret.length <= 0)
            return false;
        return true;
    }
    setEncryptSecret(passphrase) {
        try {
            let oldpassphrase = this.getPassphrase();
            if (oldpassphrase.length > 0) {
                throw new Error(`setEncryptSecret: passphrase already stored`);
            }
            else {
                oldpassphrase = this.globalUtil != null ? this.globalUtil.secret : '';
                if (oldpassphrase.length <= 0) {
                    throw new Error(`setEncryptSecret: globalUtil is null`);
                }
                // check if some databases were encrypted with the initial secret 'sqlite secret'
                this.changeDatabaseSecret(oldpassphrase, passphrase).then(() => {
                    this.storage.set('userData', { passphrase: passphrase }, function (error) {
                        if (error)
                            throw new Error(`setEncryptSecret: ${error.message}`);
                    });
                    return;
                });
            }
        }
        catch (err) {
            throw new Error(`setEncryptSecret: ${err}`);
        }
    }
    changeEncryptSecret(oldpassphrase, passphrase) {
        try {
            // check if some databases were encrypted with the oldpassphrase
            this.changeDatabaseSecret(oldpassphrase, passphrase).then(() => {
                this.setPassphrase(passphrase);
            });
        }
        catch (err) {
            throw new Error(`changeEncryptSecret: ${err}`);
        }
    }
    clearEncryptSecret() {
        try {
            let oldpassphrase = this.getPassphrase();
            if (oldpassphrase.length <= 0) {
                oldpassphrase = this.globalUtil.secret;
            }
            // check if some databases were encrypted with the oldpassphrase
            this.changeDatabaseSecret(oldpassphrase, '').then(() => {
                this.removePassphrase();
            });
        }
        catch (err) {
            throw new Error(`clearEncryptSecret: ${err}`);
        }
    }
    checkEncryptSecret(passphrase) {
        const storedPassphrase = this.getPassphrase();
        if (storedPassphrase.length <= 0) {
            throw new Error(`checkEncryptSecret: No passphrase stored`);
        }
        if (storedPassphrase === passphrase) {
            return true;
        }
        else {
            return false;
        }
    }
    async changeDatabaseSecret(oldpassphrase, newpassphrase) {
        try {
            // get the database folder
            const pathDatabase = this.fileUtil.getDatabasesPath();
            // get the list of databases
            const files = await this.fileUtil.getFileList(pathDatabase);
            files.forEach(async (dbName) => {
                const filePath = this.fileUtil.getFilePath(dbName);
                const isEncrypt = await this.sqliteUtil.isDBEncrypted(filePath);
                if (isEncrypt) {
                    this.sqliteUtil.changePassword(filePath, oldpassphrase, newpassphrase);
                }
            });
            return;
        }
        catch (err) {
            throw new Error(`changeDatabaseSecret: ${err}`);
        }
    }
    getPassphrase() {
        const data = this.storage.getSync('userData');
        const keys = Object.keys(data);
        if (data == null || keys.length <= 0)
            return '';
        if (Object.keys(data).includes('passphrase')) {
            return data.passphrase;
        }
        else {
            return '';
        }
    }
    setPassphrase(passphrase) {
        const data = this.storage.getSync('userData');
        data.passphrase = passphrase;
        this.storage.set('userData', data, function (error) {
            if (error)
                throw new Error(`setPassphrase: ${error.message}`);
        });
    }
    removePassphrase() {
        const data = this.storage.getSync('userData');
        delete data.passphrase;
        this.storage.set('userData', data, function (error) {
            if (error)
                throw new Error(`removePassphrase: ${error.message}`);
        });
    }
}
exports.UtilsSecret = UtilsSecret;
//# sourceMappingURL=utilsSecret.js.map